import BodyText from "./BodyText";
import Box from "./Box";
import ItemCondition from "./ItemCondition";
import ItemPrice from "./ItemPrice";
import ProductAttribute from "./ProductAttribute";
import ProductName from "./ProductName";
import PropTypes from "prop-types";
import React from "react";
import ItemPriceComparison from "./ItemPriceComparison";

function ProductDetails({ product }) {
  const ageGenderMap = {
    female: {
      adult: "Womens",
      child: "Girls",
      baby: "Girls",
    },
    male: {
      adult: "Mens",
      child: "Boys",
      baby: "Boys",
    },
    unisex: {
      adult: "Unisex",
      child: "Unisex Child",
      baby: "Unisex Baby",
    },
  };

  return (
    <Box>
      <ProductName name={product.title} brand={product.brand.name} />
      <Box borderBottom="1px solid black" pb="12px">
        {product.condition && (
          <Box display="flex" py="26px" gap="9px">
            <ItemCondition condition={product.condition} />
            {product.repaired && <ItemCondition condition="repaired" />}
          </Box>
        )}
        <Box>
          <BodyText>{ageGenderMap[product.gender][product.ageGroup]}</BodyText>
          <ProductAttribute attribute={{ name: "Size", value: product.size }} />
          {product.colour && (
            <ProductAttribute
              attribute={{ name: "Colour", value: product.colour }}
            />
          )}
          {product.attributes.map((attribute) => {
            return (
              <ProductAttribute
                key={`${attribute.name}-${attribute.value}`}
                attribute={attribute}
              />
            );
          })}
        </Box>
      </Box>
      <Box my={20}>
        {product.priceData.brandRrp ? (
          <ItemPriceComparison data={product.priceData} />
        ) : (
          <ItemPrice price={product.priceData.price} />
        )}
      </Box>
    </Box>
  );
}

export default ProductDetails;

ProductDetails.propTypes = {
  product: PropTypes.shape({
    title: PropTypes.string.isRequired,
    brand: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    attributes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};
